__turbopack_context__.v({
  "item": "u_VV9G_item",
  "minimal_navbar": "u_VV9G_minimal_navbar",
  "shimmer": "u_VV9G_shimmer",
  "text-bar-sweep": "u_VV9G_text-bar-sweep",
});
